import { format, isValid, parseISO } from 'date-fns';

/** Incident times are stored as UTC ISO strings (e.g. 2026-10-26T22:30:00+00:00 for 9:30 am on 27 Oct in NSW).
 *  Slicing that string showed the UTC day — the day before for morning reports — so render on the viewer's local
 *  calendar. parseISO keeps a value without an offset (picker wire value / date-only) as local wall time. */
const toLocal = (v) => { if (!v) return null; const d = parseISO(String(v)); return isValid(d) ? d : null; };

export const incidentLocalDate = (v) => { const d = toLocal(v); return d ? format(d, 'yyyy-MM-dd') : (v ? String(v).slice(0, 10) : ''); };
export const incidentLocalDateTime = (v) => { const d = toLocal(v); return d ? format(d, 'yyyy-MM-dd HH:mm') : (v ? String(v).replace('T', ' ').slice(0, 16) : ''); };
